module.exports = __webpack_public_path__ + "img/pf-07e61568--carolinetranlollaland090-copy-1.5f8020bf.jpeg";